import React, { Component } from "react";
import { Layout, Radio, Collapse, Popconfirm, Icon, Button } from "antd";
import { Parse } from "parse";

import { FormattedMessage, FormattedHTMLMessage, defineMessages,   injectIntl } from "react-intl";

import MypageNav from "../../components/navigation/MypageNav";
import Headline from "../../components/Headline";
import Korea from "./PayoutsForm/korea";
import Vietnam from "./PayoutsForm/vietnam";
import Paypal from "./PayoutsForm/paypal";
import PayoutModalUI from "./PayoutsForm/PayoutModalUI";
import "../../styles/Payouts.css";
import { getCreditOfUser } from "../../utils/fetchDataFromDB";

const { Content } = Layout;
const RadioGroup = Radio.Group;
const Panel = Collapse.Panel;

const messages = defineMessages({
  korean: {
    id: "Payouts.collapse.header.korean",
    defaultMessage: "If you have a Korean account",
  },
  vietnamese: {
    id: "Payouts.collapse.header.vietnamese",
    defaultMessage: "If you have a Vietnamese account",
  },
  other: {
    id: "Payouts.collapse.header.other",
    defaultMessage: "International (If you use PayPal)",
  },
});

class Payouts extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      payoutVisible: false,
      selectedPayout: props.intl.locale === "ko" ? "korea" : "paypal",
      credit: 0,
    };
  }

  render() {
    const { formatMessage, locale } = this.props.intl;
    const { credit, visible, payoutVisible, selectedPayout } = this.state;

    return (
      <div>
        <Layout style={{ background: "#fff" }}>
          <MypageNav selectedKey={"remittance-request"} />
          <Content style={{ margin: 20 }}>
            <Headline id="Payouts.headline" defaultMessage="Remittance Request" />
            <div style={{ margin: "0px 25px" }}>
              <img src="https://www.paypalobjects.com/webstatic/mktg/logo/PP_AcceptanceMarkTray-NoDiscover_243x40.png" alt="PayPal" />

              <div>
                <div className="payouts-caution">
                  <span style={{ color: "#ff6060" }}>* </span>
                  <FormattedMessage id="Payouts.select.account" defaultMessage="Please select an account to receive the remittance." />
                </div>
                <p className="payouts-caution-explain">
                  <FormattedMessage id="Payouts.select.account.explain" defaultMessage="(You can request a remittance starting with a revenue of $100 or more.)" />
                </p>
                <RadioGroup value={selectedPayout} onChange={(e) => this.setState({ selectedPayout: e.target.value })} style={{ display: "block", marginBottom: 46 }}>
                  <Radio value="paypal" style={{ display: "block", marginBottom: "7px" }}>
                    <FormattedMessage id={"Payouts.radio.other"} defaultMessage={"International (PayPal)"} />
                  </Radio>
                  <Radio value="korea" style={{ display: "block", marginBottom: "7px" }}>
                    <FormattedMessage id={"Payouts.radio.korean"} defaultMessage={"Korean"} />
                  </Radio>
                  <Radio value="vietnam" style={{ display: "block", marginBottom: "32px" }}>
                    <FormattedMessage id={"Payouts.radio.vietnamese"} defaultMessage={"Vietnamese"} />
                  </Radio>
                </RadioGroup>
                {selectedPayout === "paypal" ? (
                  <p style={{ color: "#ff6060", marginBottom: 20, fontSize: 16 }}>
                    <FormattedMessage id={"Payouts.korean.guide.phrase"} defaultMessage={"If you are Korean, Please choose Korean instead of PayPal."} />
                  </p>
                ) : null}
                {
                  <Popconfirm
                    placement="top"
                    visible={visible}
                    onVisibleChange={this.onVisibleChangeOfConfirm}
                    title={
                      <div style={{ width: "max-content", marginRight: locale === "ko" ? 35 : 60, marginTop: 0 }}>
                        <FormattedHTMLMessage
                          id="Payouts.confirm.message"
                          defaultMessage="<b>Insufficient Remittable Revenue</b><div>You can request a remittance when<br/>the remittable revenue is $100 or more.</div>"
                        />
                      </div>
                    }
                    okText="OK"
                    cancelText={
                      <span style={{ color: "#000" }}>
                        <FormattedMessage id="Payouts.confirm.cancelText" defaultMessage="Check the Remittable Revenue" />
                      </span>
                    }
                    onCancel={() => this.props.history.push('./remittance-info')}
                    icon={<Icon type="exclamation-circle" theme="filled" style={{ marginTop: 3 }} />}>
                    <Button type="primary" className="payouts-request-btn" style={{float : 'none', margin:' 0 0 10px 0'}}>
                      <FormattedMessage id="Payouts.btn" defaultMessage="Remittance Request" />
                    </Button>
                  </Popconfirm>
                }

                <p className="payouts-caution">
                  <span style={{ color: "#ff6060" }}>* </span>
                  <FormattedMessage id="Payouts.check.apply" defaultMessage="Please make sure to check the following before requesting the remittance." />
                </p>

                <Collapse className="payouts-collapse">
                  <Panel header={formatMessage(messages.other)} key="1">
                    <FormattedHTMLMessage
                      id={"Payouts.collapse.other"}
                      defaultMessage={
                        "You can use PayPal’s Premier or Business Account.<br/><br/>First, you need PayPal ID.<br/>Register your account on the PayPal site.<br/><br/>In addition, the email in the stickerfarm account must be the same as the email in the PayPal account.<br/>If not, check the PayPal site for ways to add email.<br/><br/>PayPal fees apply. <br/>To learn more about fees, please visit the fees page for your country.<br/><br/>※ You can not use your personal account. <br/>     Please check PayPal for the type of PayPal account.<br/><br/>※ Please make sure your PayPal account can receive U.S dollars.<br/><br/>※ You can not register with PayPal account if you are living in Korea."
                      }
                    />
                  </Panel>
                  <Panel header={formatMessage(messages.korean)} key="2">
                    <FormattedHTMLMessage
                      id={"Payouts.collapse.korean"}
                      defaultMessage={
                        "In Korea, you need to enter your name, e-mail, account number and resident<br/> registration number of the bank.<br/>Email must be entered using the e-mail you subscribed to."
                      }
                    />
                  </Panel>
                  <Panel header={formatMessage(messages.vietnamese)} key="3">
                    <FormattedHTMLMessage
                      id={"Payouts.collapse.vietnamese"}
                      defaultMessage={
                        "In Veitnam, you need to enter the name of the beneficiary, <br/>the tax code and the account information.<br/>It is the individual's responsibility to pay personal income tax.<br/><br/>Email must be entered using the e-mail you subscribed to."
                      }
                    />
                  </Panel>
                </Collapse>
              </div>
              <PayoutModalUI
                visible={payoutVisible}
                onCancel={() => this.setState({ payoutVisible: false })}
                payoutForm={
                  selectedPayout === "korea" ? (
                    <Korea credit={credit} onCancel={() => this.setState({ payoutVisible: false })} />
                  ) : selectedPayout === "vietnam" ? (
                    <Vietnam credit={credit} onCancel={() => this.setState({ payoutVisible: false })} />
                  ) : (
                    <Paypal credit={credit} onCancel={() => this.setState({ payoutVisible: false })} />
                  )
                }
              />
            </div>
          </Content>
        </Layout>
      </div>
    );
  }

  onVisibleChangeOfConfirm = async (visible) => {
    if (!visible) {
      this.setState({ visible });
      return;
    }

    const credit = await getCreditOfUser(Parse.User.current());

    if (credit >= 100) {
      //모달 띄우기
      this.setState({
        payoutVisible: true,
        credit,
      });
    } else {
      this.setState({ visible }); // show the popconfirm
    }
  };
} //Payout Component end
 
Payouts = injectIntl(Payouts);

export default Payouts;
